<template>
    <section class="growth">
        <div class='title'>
            <img src="/images/base/share_img.jpg" class='tips'>
            <span>trewtret</span>
            
        </div>

        <div class='card' v-if='list.length != 0 '>
            <div class='card_item' v-for='(item,index) in list' :key='index' @click='toShare(item)'>
                <img :src="item.icon | formatImgUrl(100,100,true)" class='img_path'>
                <div>{{item.name}}</div>
            </div>
        </div>
        <div class='card' v-else>
            <div class='no_list'>
                该客机暂无任何营销活动，请检查

            </div>
            
        </div>
        <div class='shadow' v-show='show' @touchmove.prevent>
            <img src="/images/my/shareMask.png" class='shareMask'>
        </div>
    </section>
</template>

<script>
    import homeApi from '@/axios/home'
    import { Dialog,Toast } from 'vant';
    import wxShare from "@/assets/js/wx.share"
    export default {
        name: 'getGrowthShare',
        data () {
            return {
                show : false,
                list : [],
                tag : false,
                name : ''
            }   
        },
        component: {
        
        },
        watch: {},
        computed: {
            groupActivityId(){
                return this.$route.query.groupActivityId;
            }
        },
        created () {
            this.getList()
        },
        mounted () {

        },
        methods: {
            toShare(item){
                if(this.tag){
                    return;
                }
                this.tag = true;
                
                let params = {
                    marketingCampaignId : item.id,
                    uinId : localStorage.getItem('unionId')
                }

                myApi.createShareCode(params).then((res)=>{
                    this.show = true;
                    this.tag = false;
                    //配置分享
                    let shareBody = {
                        title : item.mainTitle,
                        desc : item.subTitle,
                        imgUrl : item.headImage.split('?')[0],
                        link : item.link + '?code=' + res
                    }
                    wxShare(shareBody).then(()=>{
                       this.show = false;
                       let patms = {
                           code : res,
                           uinId : localStorage.getItem('unionId')
                       }
                        myApi.shareGoodsBack(patms).then((res)=>{
                           
                        })
                    });
                }).catch(()=>{
                    this.tag = false;
                })
            },
            getGoods(){
                
                let {groupActivityId} = this               
                homeApi.getAwardGoods({groupActivityId}).then((res)=>{
                    this.list = res;
                })
            },
            getList(){
                // let uinId = localStorage.getItem('unionId');
                // if(!uinId){
                //     Toast('请重新登录');
                //     setTimeout(()=>{
                //         sessionStorage.setItem('url', location.href)
                //         this.$store.commit('token', '');
                //         localStorage.clear();
                //         location.replace(location.origin + '/login');
                //     },2000)
                //     return;
                // }
                let {groupActivityId} = this               
                homeApi.getAward({groupActivityId}).then((res)=>{
                    this.list = res;
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .shareMask{
        width: 80%;

    }
    .shadow{
        position:fixed;
        width: 100%;
        height: 100vh;
        background:rgba(0,0,0,0.8);
        top:0;
        left:0;
        color:#fff;
        font-size: 50px;
        text-align: center;
        padding-top:10%;
    }
    .growth{
        background: #EDEDED;
        height: 100vh;
        padding: 36px;
        .card{
            background: #fff;
            border-radius:30px;
            min-height: 500px;
            margin-top: 36px;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .card_item{
                display: flex;
                margin-left: 1%;
                width: 30%;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 28px;
                font-weight: 500;
                height: 200px;
                div{
                    display:block;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                    width:200px;
                    text-align: center;
                }
                .img_path{
                    width: 84px;
                    height: 84px;
                    margin-bottom: 20px;
                }
            }
        }
        .title{
            font-size: 28px;
            color: #333333;
            line-height: 90px;
            display: flex;
            font-weight:500;
            align-items: center;
            span{
                position: relative;
                top:5px;
            }
            .tips{
                width: 82px;
                height: 82px;
                border-radius:41px; 
                margin-right: 20px;
            }
        }
    }
    .no_list{
        font-size: 40px;
        color:#333;
        padding: 30px;
    }

</style>
